import React from 'react'
import "./separator_2.css"
const Separator_2 = () => {
  return (
    <div className='separator2-container'>
        <div className='separator2'>
            <h1> <strong>QUE NO TE ARRASTREN LOS ACCIDENTES EXTERIORES; PROCÚRATE TIEMPO LIBRE PARA APRENDER ALGO BUENO Y CESA YA DE GIRAR COMO UN TROMPO.</strong></h1>
        </div>
    </div>
  )
}

export default Separator_2